import { SupportCodeStorage } from './types';
import { generateCode } from './generateCode';

export class SupportCodeService {
  constructor(private readonly storage: SupportCodeStorage) {}
  getCode() {
    let v = this.storage.getItem();
    if (v) {
      return v;
    }
    v = generateCode();
    this.storage.setItem(v);
    return v;
  }
}
